
const RadioBox = function (props) {
	
	var defaultValue = ( props.defaultValue === "true" || props.defaultValue === "false") ?
	  JSON.parse(props.defaultValue)
	: props.defaultValue;

	defaultValue = isNaN(defaultValue) ? defaultValue : parseInt(defaultValue);


	return <div className="question radio-box" id={"question-"+ props.modelName}>
		
		{ props.options.map( (option ,i)=>(
			<>
				<div className="qrow" htmlFor={props.modelName + option}>
					<input type="radio" 
						name= {"choix" + props.modelName }
						key= {i}
						id= {props.modelName + option }
						checked= { i === defaultValue }
						value= {i}
						onChange= {(e) => ( props.handler( i , props.modelName) )}
					/>
					<span className="checkmark"></span>
					<label >{option}</label> 
				</div>
				{(props.modelName === "enfants" &&  option === "Oui" && ( i === defaultValue) ) ?
					<> nombre enfant </> : ""
				}
			</> 
			))}
	</div>
};

export  {RadioBox};